import { DynamicQuestionCode, DynamicQuestionsData } from 'types/dynamicFields'
import { getObjectFromString } from 'utils/jsonData'
import { QuestionMapping } from './questionMapping'
import { DynamicQuestionsStep, DynamicQuestionsSteps } from './types'

export const useRequiredSteps = (questionsData: DynamicQuestionsData[]) => {
  const getRequiredQuestionKeys = (stepKey: string) => {
    const requiredQuestionCodes = questionsData?.map(({ code }) => code)
    const questionKeys = Object.keys(QuestionMapping[stepKey]) as DynamicQuestionCode[]
    return questionKeys?.filter(questionKey => requiredQuestionCodes?.includes(questionKey))
  }

  const getRequiredQuestions = (stepKey: string, questionKeys: DynamicQuestionCode[]) => {
    return questionKeys?.reduce((questions, questionKey) => {
      const questionData = questionsData?.find(({ code }) => code === questionKey)
      const savedAnswer = getObjectFromString(questionData?.value?.answer)
      questions[questionKey] = {
        ...QuestionMapping?.[stepKey]?.[questionKey],
        savedAnswer,
      }
      return questions
    }, {} as DynamicQuestionsStep)
  }

  const getRequiredSteps = () => {
    return Object.keys(QuestionMapping)?.reduce((steps, stepKey) => {
      const requiredQuestionKeys = getRequiredQuestionKeys(stepKey)
      if (requiredQuestionKeys?.length) {
        steps[stepKey] = getRequiredQuestions(stepKey, requiredQuestionKeys)
      }
      return steps
    }, {} as DynamicQuestionsSteps)
  }

  return { getRequiredSteps }
}
